import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'table-datatable-drop-off-string',
  templateUrl: './datatable-drop-off-string.component.html',
  styleUrls: ['./datatable-drop-off-string.component.scss'],
  imports: [MatButtonModule],
})
export class DatatableDropOffStringComponent {
  dropOffId = input<number>();
  collarId = input<number>();
  type = input<'internal' | 'external'>();
  value = input<string>();
  isCompactModeActivated = input<boolean>();

  showDropOff = output<{ dropOffId: number; collarId: number; type: 'internal' | 'external' }>();

  onClickDropoff() {
    this.showDropOff.emit({
      dropOffId: this.dropOffId(),
      collarId: this.collarId(),
      type: this.type(),
    });
  }
}
